import { Wizard } from "./wizard";

export type ActionHandler = (wizard: Wizard) => void;

export class Action {
    #label : string;
    #classes: string;
    #actionHandler: ActionHandler;

    get label() {
        return this.#label;
    }

    get classes() {
        return this.#classes;
    }

    get execute() {
        return this.#actionHandler;
    }

    constructor(label: string, classes: string, actionHandler: ActionHandler) {
        this.#label = label;
        this.#classes = classes;

        if (typeof actionHandler !== "function") {
            throw "actionHandler should be a function";
        }
        this.#actionHandler = actionHandler;
    }
}
